import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CONSTANTS } from 'common/constants';
import dashboardNotificationAPI from 'store/api/notification.api';

interface IState {
    notificationData: { [key: string]: string }[];
    status: string;
}

const initialState: IState = {
    notificationData: [],
    status: CONSTANTS.IDLE
};
export interface caseType {
    [key: string]: string;
}
export const getNotification = createAsyncThunk('common/getNotification', async (_, { getState }) => {
    const { account } = getState() as { account: any };
    const response: { [key: string]: string }[] = await dashboardNotificationAPI(account?.user?.uen || account?.user?.id);
    return response;
});

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        deleteNotification(state, action) {
            state.notificationData.filter((_: any, index: number) => index !== action.payload);
        },
        resetNotification(state) {
            state.notificationData = [];
            state.status = CONSTANTS.IDLE;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotification.fulfilled, (state, action) => {
                if (action.payload) {
                    state.notificationData = action.payload!;
                }
                state.status = CONSTANTS.FULFILLED;
            })
            .addCase(getNotification.pending, (state) => {
                state.status = CONSTANTS.LOADING;
            })
            .addCase(getNotification.rejected, (state) => {
                state.status = CONSTANTS.FAILED;
            });
    }
});

export const { deleteNotification,resetNotification } = notificationSlice.actions;


export default notificationSlice.reducer;
